import { FunctionComponent, useState } from 'react'
import './GenericPopup.css'

type PopupButton = {
  text: string,
  callback: () => void
}

interface GenericPopupProps {
  popupImage: string,
  title: string,
  description: string,
  buttonText: string,
  extraButtons?: PopupButton[]
  callback: () => void
}

const GenericPopup: FunctionComponent<GenericPopupProps> = (props) => {
  const extraButtons: JSX.Element[] = []
  const [animationClass, setAnimationClass] = useState(['animation-fadeIn', 'animation-popup-enter'])

  if (props.extraButtons !== undefined) {
    props.extraButtons.forEach(buttonDeff => {
      extraButtons.push((<button className='btn_long--blank' onClick={buttonDeff.callback}>{buttonDeff.text}</button>))
    })
  }

  function handleButtonClick () {
    setAnimationClass(['animation-fadeOut', 'animation-popup-leave'])
    setTimeout(() => {
      props.callback()
    }, 1000)
  }

  return (
    <div className='w-full h-full top-0 left-0 absolute grid content-center'>
      <div className={'absolute inset-0 bg-primary-darkTransparent ' + animationClass[0]}></div>
      <div
        className={'relative mx-auto w-[334px] h-[400px] bg-primary-white text-center rounded-[24px] flex item-center p-[15px] ' +
          animationClass[1]}>
        <div className='w-full relative translate-y-[-60px]'>
          <img src={props.popupImage} className='object-contain mx-auto'></img>
          <p className='text-2xl text-primary-blue font-bold'>{props.title}</p>
          <p className='my-[10px]'>{props.description}</p>
        </div>
        <div className='absolute left-0 bottom-0 right-0'>
          <button className='btn_long--blue' onClick={handleButtonClick}>{props.buttonText}</button>
          {extraButtons}
          <div className='h-[40px]' />
        </div>
      </div>
    </div>
  )
}

export default GenericPopup
